module.exports = __webpack_public_path__ + "static/media/deactive_synthesized_audio.42fac978.svg";